import { electricityConfig, scopeConfigs } from './config';
import { MediumType, ScopeKey } from './types';

export const renderCellValue = (value: unknown) => {
  if (Array.isArray(value)) {
    const text = value.map(item => {
      if (typeof item !== 'object' || !item) return item;
      const record = item as Record<string, unknown>;
      return record.name ?? record.deviceName;
    });
    return text.length ? text.join('、') : '--';
  }
  if (value === undefined || value === null || value === '') return '--';
  return String(value);
};

export const getCurrentScope = (energy: MediumType, scope: ScopeKey) =>
  energy === MediumType.Electricity ? ScopeKey.Factory : scope;

export const getCurrentConfig = (energy: MediumType, scope: ScopeKey) =>
  energy === MediumType.Electricity ? electricityConfig : scopeConfigs[getCurrentScope(energy, scope)];
